export default "__VITE_ASSET__Buz7DupU__"